import qs from 'qs';
import axios from 'axios';
import { call } from 'redux-saga/effects';
import { GET_LAST_COMMENTS_ENDPOINT } from '../config/apiEndpoints';
import { getTokenHeaders as tokenHeader } from '../helpers/api.helper';

export function* getLastComments(payload) {
    const header = tokenHeader();
    return yield call(axios.get, GET_LAST_COMMENTS_ENDPOINT, qs.stringify(payload), {header});
}



// WEBPACK FOOTER //
// ./src/SHARED/api/comments.api.js